import React, { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Row, Col, Button, FormControl, ControlLabel, Checkbox } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { _renderUserMenuItemChildren } from '../../../functions/reactTypeaheadRenderMenuItemChildren'
import { editUser } from '../../login/reducers/manageLogin'

const EditUserWorkloadStatus = (props) => {
    const [ employee, setEmployee ] = useState([])
    const [ billable, setBillable ] = useState(false)
    const [ fullTime, setFullTime ] = useState(false)
    const [ expectedHours, setExpectedHours ] = useState(0)
    const [ saving, setSaving ] = useState(false)

    const resetEmployeeInfo = () => {
        setEmployee([])
        setBillable(false)
        setFullTime(false)
        setExpectedHours(0)
    }

    const handleSelectEmployee = (employee) => {
        if (!Array.isArray(employee) || !employee.length) {
            return resetEmployeeInfo()
        }

        setEmployee(employee)
        setBillable(employee[0].billable || false)
        setFullTime(employee[0].full_time || false)
        setExpectedHours(employee[0].expected_hours || 0)
    }

    const handleSave = () => {
        if (saving || !Array.isArray(employee) || !employee[0]) {
            return
        }

        setSaving(true)

        const user = employee[0]

        
        const payload = {
            billable,
            full_time: fullTime,
            expected_hours: Number(expectedHours),
        }
        
        axios({
            method: "PATCH",
            url: user.url,
            headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
            data: payload,
        })
            .then(response => {
                swal({
                    title: "Success",
                    text: `${user.first_name}'s workload tracker status has been updated.`,
                    icon: "success",
                    button: "Continue",
                })

                const updatedUser = { ...user, ...payload }
                props.editUser(updatedUser)
                resetEmployeeInfo()
            })
            .catch(error => {
                swal({
                    title: "Error",
                    text: `There was an error updating ${user.first_name}'s workload tracker status. If the proplem persists, please contact support@genesisrg.com`,
                    icon: "error",
                    button: "Continue",
                })
            })
            .finally(() => {
                setSaving(false)
            })
    }

    const genesisEmployees = props.users.filter(user => {
        return user && user.email && user.email.includes('genesisrg') && (!user.department || user.department.toLowerCase() !== 'former employee')
    })
    .sort((a, b) => a.first_name.localeCompare(b.first_name))

    return (
        <div>
            <ControlLabel>
                Select Employee
            </ControlLabel>
            <Row>
                <Col xs={12} md={8}>
                    <div>
                        <Typeahead
                            id="EmployeeSelectionTypeahead"
                            clearButton
                            labelKey={user => `${user.first_name} ${user.last_name}`}
                            multiple={false}
                            renderMenuItemChildren={_renderUserMenuItemChildren}
                            selected={employee}
                            options={genesisEmployees}
                            placeholder="Select employee..."
                            onChange={handleSelectEmployee}
                        />
                    </div>

                    {Array.isArray(employee) && employee.length ?
                        <Fragment>
                            <br />
                            <ControlLabel>
                                Expected Hours
                            </ControlLabel>
                            <FormControl
                                style={{ marginBottom: '15px' }}
                                type="number"
                                step="0.5"
                                value={expectedHours}
                                placeholder="Enter expected hours"
                                onChange={(e) => setExpectedHours(e.target.value)}
                            />

                            <Checkbox
                                style={{ marginBottom: '15px' }}
                                checked={fullTime}
                                onChange={() => setFullTime(!fullTime)}
                            >
                                <strong>
                                    Full Time?
                                </strong>
                            </Checkbox>

                            <Checkbox
                                checked={billable}
                                onChange={() => setBillable(!billable)}
                            >
                                <strong>
                                    Billable?
                                </strong>
                            </Checkbox>

                            <Button
                                onClick={handleSave}
                                disabled={saving}
                                bsStyle="primary"
                            >
                                Save
                            </Button>
                        </Fragment>
                        :
                        null
                    }
                </Col>
            </Row>

        </div>
    )
}

export default connect(null, { editUser })(EditUserWorkloadStatus)


// WEBPACK FOOTER //
// ./src/routes/manager/components/EditUserWorkloadStatus.js